module.exports = __webpack_public_path__ + "img/only_logo.4fb9f7e6.png";